export enum CustomFields {
  IsChangedManual = 'IsChangedManual',
  IsChangedCManual = 'IsChangedContractualManual',
  IsChangedTManual = 'IsChangedTransactionalManual',

  IsChangedSoBManual = 'IsChangedSoBManual',

  IsChangedUnitsManual = 'IsChangedUnitsManual',
  IsChangedUnitsCManual = 'IsChangedUnitsContractualManual',
  IsChangedUnitsTManual = 'IsChangedUnitsTransactionalManual',

  IsNoPlan = 'IsNoPlan',
  IsNoPlanContractual = 'IsNoPlanContractual',

  Justify = 'Justification',
  JustifyC = 'JustificationContractual',
  JustifyT = 'JustificationTransactional',

  JustifySob = 'JustificationSob',

  JustifyUnits = 'JustificationUnits',
  JustifyUnitsC = 'JustificationUnitsContractual',
  JustifyUnitsT = 'JustificationUnitsTransactional',
}
